import { CanadaPopUp } from "@cxc/react-fds-components";
import React, { useState } from "react";
import { EXTERNAL_URL_MARKER } from "../../utils/externalUrl";

interface UseCanadaPopupReturnProps {
  CanadaPopUp: React.ReactNode;
  setIsPopupVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setPopupUrl: React.Dispatch<React.SetStateAction<string>>;
}

export const useCanadaPopUp = (): UseCanadaPopupReturnProps => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupUrl, setPopupUrl] = useState("#");

  return {
    CanadaPopUp: (
      <CanadaPopUp
        isVisible={isPopupVisible}
        buttonOneLink={popupUrl + EXTERNAL_URL_MARKER}
        onClickFunction={() => setIsPopupVisible(false)}
      />
    ),
    setPopupUrl,
    setIsPopupVisible,
  };
};
